//#region Imports
import { assertBoolean, SETTINGS_AUTH_CHECK_EMAIL_URL } from "@anydo/core";
import { fetchAuth } from "../fetchAuth";
import { createAuthHeaders } from "./createAuthHeaders";
//#endregion

/**
 * Checks if email is of registerd user or not
 */
export async function checkAuthUserEmail(email: string): Promise<{ isUserExists: boolean; mustUseCaptcha: boolean }> {
  const data = await fetchAuth<{ user_exists: boolean; use_captcha: boolean }>(SETTINGS_AUTH_CHECK_EMAIL_URL, {
    method: "POST",
    headers: createAuthHeaders(),
    body: JSON.stringify({
      email,
    }),
  });

  const isUserExists = data.user_exists;
  assertBoolean(isUserExists);

  return {
    isUserExists,
    mustUseCaptcha: data.use_captcha,
  };
}
